import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Content from './pages/Content';
import reportWebVitals from './reportWebVitals';
import './scss/custom.scss';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Content />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
